const staff_movie = () => {
    if (document.querySelector('#page-staff') === null) return;

    const movie = document.querySelector('.pg-staff-detail-fixed__catch');
    const container = document.querySelector('.pg-staff-detail-fixed');
    const header = document.querySelector('.l-header');
    if (!movie || !container) return;

    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.style.flexShrink = '0';
    movie.parentNode.insertBefore(placeholder, movie);

    let lastState = '';
    let isEnabled = window.innerWidth > 768;

    const updatePosition = () => {
        if (!isEnabled) {
            placeholder.style.display = 'none';
            movie.style.position = 'relative';
            movie.style.left = '';
            movie.style.top = '';
            movie.style.bottom = '';
            movie.style.width = '';
            return;
        }

        const scrollY = window.scrollY;
        const containerTop = container.offsetTop;
        const containerHeight = container.offsetHeight;
        const movieHeight = movie.offsetHeight;
        const headerHeight = header ? header.offsetHeight : 0;

        const movieRect = container.getBoundingClientRect();
        const currentMovieLeft = movieRect.left + window.scrollX;
        const currentMovieWidth = movieRect.width;

        const startFix = containerTop;
        const endFix = containerTop + containerHeight - movieHeight;

        // ■ relative 状態
        if (scrollY < startFix) {
            if (lastState !== 'relative') {
                placeholder.style.display = 'none';
                movie.style.position = 'relative';
                movie.style.left = '';
                movie.style.top = '';
                movie.style.bottom = '';
                movie.style.width = '';
                lastState = 'relative';
            }
            return;
        }

        // ■ FIXED 状態
        if (scrollY >= startFix && scrollY < endFix) {

            // ★★ 先に placeholder を表示して幅と高さを確定（ここ重要）
            placeholder.style.display = 'block';
            placeholder.style.width = currentMovieWidth + 'px';
            placeholder.style.height = movieHeight + 'px';

            // ★★ FIXED 用の left/top を計算
            const fixedLeft = currentMovieLeft;
            const fixedTop = headerHeight;

            // ★★ requestAnimationFrame 内で一括適用し、
            // ★★ 1フレーム後に position:fixed を適用（ガタつき防止）
            requestAnimationFrame(() => {
                movie.style.position = 'fixed';
                movie.style.left = fixedLeft + 'px';
                movie.style.top = fixedTop + 'px';
                //movie.style.width = currentMovieWidth + 'px';
                movie.style.bottom = 'auto';
            });

            lastState = 'fixed';
            return;
        }

        // ■ absolute 状態（スクロール終点）
        if (lastState !== 'absolute') {
            placeholder.style.display = 'block';
            placeholder.style.width = currentMovieWidth + 'px';
            placeholder.style.height = movieHeight + 'px';

            movie.style.position = 'absolute';
            movie.style.left = '0px';
            movie.style.bottom = '0px';
            movie.style.top = 'auto';
            //movie.style.width = currentMovieWidth + 'px';

            lastState = 'absolute';
        }
    };

    const handleResize = () => {
        const nowEnabled = window.innerWidth > 768;
        isEnabled = nowEnabled;

        placeholder.style.width = '';
        placeholder.style.height = '';

        lastState = '';
        updatePosition();
    };


    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', handleResize);
    updatePosition();
};
export default staff_movie;
